// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-control-ColumnComparisonBlock-ColumnComparisonBlock-module__header webpack-concepts-Extraction-Compare-ComparisonTable-ComparisonTable-module__paddedCell";
export { _1 as "header" }
